const windowEnvKey = '__ENV__';

declare global {
  interface Window {
    [windowEnvKey]?: Record<string, string>;
  }
}

class EmptyEnvValue {
  constructor(private value: any) {}

  public string(): undefined {
    return this.value;
  }

  public number(): undefined {
    return this.value;
  }

  public boolean(): undefined {
    return this.value;
  }

  public json(): undefined {
    return this.value;
  }
}

class EnvValue {
  private booleanDefsFalse = ['false', '0'].map((v) => v.toLowerCase());
  private booleanDefsTrue = ['true', '1'].map((v) => v.toLowerCase());

  constructor(private value: any) {}

  public string(): string {
    return this.value.toString();
  }

  public number(): number {
    if (isNaN(+this.value)) throw new Error('Invalid number');

    return +this.value;
  }

  public boolean(): boolean {
    const val = this.value.toString().toLowerCase();

    if (this.booleanDefsFalse.includes(val)) return false;
    if (this.booleanDefsTrue.includes(val)) return true;

    throw new Error('Invalid boolean value');
  }

  public json(): object {
    return JSON.parse(this.value);
  }
}

export function getEnv(key: string): EnvValue;
export function getEnv(key: string, opts?: { optional?: true }): EnvValue | EmptyEnvValue;
export function getEnv(key: string, opts?: { optional?: boolean }): EnvValue | EmptyEnvValue {
  if (window[windowEnvKey] && key in window[windowEnvKey]) {
    return new EnvValue(window[windowEnvKey][key]);
  }

  if (opts?.optional) {
    return new EmptyEnvValue(undefined);
  }

  throw new Error(`Environment variable ${key} is not defined`);
}

export function eraseEnv(): void {
  document?.getElementById('__env')?.remove();
  delete window[windowEnvKey];
}
